import { render } from "./FormControl.vue?vue&type=template&id=5cf23639&scoped=true&ts=true&lang=pug"
import script from "./FormControl.vue?vue&type=script&lang=ts"
export * from "./FormControl.vue?vue&type=script&lang=ts"

import "./FormControl.vue?vue&type=style&index=0&id=5cf23639&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cf23639"]])

export default __exports__